/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { VIEW_TYPES } from 'components/common/view-type/settings'
import { get } from 'utils/lodash'

const { LIST } = VIEW_TYPES

const initialState = {
  viewType: LIST,
}

const disposalSitesSlice = createSlice({
  name: 'persistentDisposalSites',
  initialState: { ...initialState },
  reducers: {
    setViewType: (state, action) => {
      state.viewType = action.payload
    },
  },
})

export const { setViewType } = disposalSitesSlice.actions

export const selectViewType = state => get(state, 'persistentDisposalSites.viewType', LIST)

export default disposalSitesSlice.reducer
